var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.39095 8.12495C4.38991 7.38371 4.5356 6.64959 4.81961 5.96491C5.10361 5.28024 5.52033 4.65854 6.04573 4.13567C6.57112 3.61279 7.19482 3.19907 7.88085 2.91837C8.56689 2.63766 9.3017 2.49551 10.0429 2.50011C13.1359 2.5231 15.6098 5.09396 15.6098 8.19557V8.74995C15.6098 11.548 16.1953 13.1717 16.7109 14.0592C16.7664 14.154 16.796 14.2618 16.7965 14.3717C16.7971 14.4816 16.7687 14.5897 16.7142 14.6851C16.6597 14.7805 16.581 14.8599 16.486 14.9151C16.391 14.9704 16.2831 14.9997 16.1732 15H3.82693C3.71703 14.9997 3.60914 14.9704 3.51415 14.9151C3.41917 14.8598 3.34045 14.7805 3.28592 14.685C3.2314 14.5896 3.20302 14.4815 3.20362 14.3716C3.20423 14.2617 3.23381 14.1539 3.28938 14.059C3.80526 13.1716 4.39094 11.5479 4.39094 8.74995L4.39095 8.12495Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15V15.625C7.5 16.288 7.76339 16.9239 8.23223 17.3928C8.70107 17.8616 9.33696 18.125 10 18.125C10.663 18.125 11.2989 17.8616 11.7678 17.3928C12.2366 16.9239 12.5 16.288 12.5 15.625V15",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell02);
export default __webpack_public_path__ + "static/media/bell-02.342156be5c7f2b8dfdc735d9475e2de5.svg";
export { ForwardRef as ReactComponent };